import type { IconData } from '@stacksjs/iconify-core'

export const contentHeart: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 5a4 4 0 0 0-8 0a4 4 0 1 0-8 0c0 6.5 8 10 8 10s8-3.5 8-10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentHeart
